import React, { useState, useEffect } from "react";
import "../Intro/Intro.css";
import image1 from "../Assets/home-slider-top-1.png";
import image2 from "../Assets/home-slider-top-2.png";
import image3 from "../Assets/home-slider-top-3.png";
import image4 from "../Assets/home-slider-top-4.png";
import image5 from "../Assets/home-slider-top-5.png";

// Main Intro component
function Intro() {
  const [current, setCurrent] = useState(0);

  // Data for slides
  const intro_data = [
    {
      image: image1,
      text: "We're in the competitive advantage business",
    },
    {
      image: image2,
      text: "Unit of Asian Aerosol group of companies",
    },
    {
      image: image3,
      text: "World class manufacturer of Pressurized Metered Dose Inhalers",
    },
    {
      image: image4,
      text: "We aim to be the leading comfort provider of pMDI's",
    },
    {
      image: image5,
      text: "Leading expertise in Inhalers Manufacturing Technology",
    },
  ];

  // Automatically change the slide every 3 seconds
  useEffect(() => {
    const slider = setInterval(() => {
      setCurrent((prev) => (prev === intro_data.length - 1 ? 0 : prev + 1));
    }, 3000);

    // Clear interval when component is unmounted
    return () => clearInterval(slider);
  }, []); // Run only on mount/unmount

  return (
    <>
      <div className="intro-slider">
        {intro_data.map((i, index) => (
          <div
            className={current === index ? "slide active" : "slide"}
            key={index}
          >
            {/* Only render the current slide */}
            {current === index && (
              <div className="intro-slider-content">
                <div className="intro-slider-left">
                  <img
                    src={i.image}
                    alt={i.text}
                    className="intro-image"
                  />
                </div>
                <div className="intro-slider-right">
                  <p className="intro-text">{i.text}</p>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Dots to indicate and navigate to the current slide */}
      <div className="intro-slideshowDots">
        {intro_data.map((_, idx) => (
          <div
            key={idx}
            className={`slideshowDot ${current === idx ? "active" : ""}`}
            onClick={() => setCurrent(idx)}
          ></div>
        ))}
      </div>
    </>
  );
}

export default Intro;
